import React from 'react'
import { Typography, makeStyles, Theme } from '@material-ui/core'
import Layout from '../components/Layout'

const useStyles = makeStyles((theme: Theme) => ({
  privacyContainer: {
    padding: theme.spacing(4, 0),
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  subsectionTitle: {
    marginBottom: theme.spacing(1.5),
    fontWeight: 500,
  },
  paragraph: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
  listItem: {
    marginBottom: theme.spacing(0.5),
    lineHeight: 1.6,
  },
}))

export const Privacy: React.FC = () => {
  const classes = useStyles()

  return (
    <Layout>
      <div className={classes.privacyContainer}>
        <Typography
          variant='h3'
          component='h1'
          className={classes.sectionTitle}
        >
          INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI ART. 13 DEL REGOLAMENTO
          UE 2016/679 (DI SEGUITO GDPR) & COOKIES POLICY
        </Typography>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Titolare (identità e dati di contatto)
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Write System S.r.l. (di seguito WS), c.f. e P.IVA 06135630728, con
            sede legale in Via Francesco Capacchione 10, 76121 – Barletta (BT),
            mail: info@writesystem.eu, in persona del proprio legale
            rappresentante pro-tempore è proprietario della piattaforma Synedrio
            e agisce come Titolare del Trattamento solo per i dati di
            navigazione del sito e di eventuali richieste dell&#39;utente
            tramite apposita sezione.
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            In merito streaming live e on-demand dell&#39;Ente caricate sulla
            piattaforma Synedrio è l&#39;Ente stesso ad esserne Titolare, WS
            opera come Responsabile del Trattamento (Art. 28 GDPR 2016/679).
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Responsabile della Protezione dei Dati
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            WS non ha l&#39;obbligo di nominare un DPO (Data Protection
            Officer).
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Tipologia di dati trattati
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Le riprese audio-video nel corso delle sedute potranno riguardare
            gli interventi dei componenti dei Consigli
            regionali/provinciali/comunali/municipali, delle Commissioni
            consiliari o altri eventi e/o dei relatori sugli argomenti iscritti
            all&#39;ordine del giorno, nonché il personale dipendente
            dell&#39;Ente addetto o partecipante alle sedute.
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            I dati personali trattati per le finalità sopraelencate sono:
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            - dati anagrafici e identificativi;
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            - immagini e audio dei componenti del consiglio/commissioni e dei
            soggetti che, a vario titolo, partecipano alle sedute.
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Finalità e base giuridica
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Le finalità del trattamento sono:
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            - favorire la partecipazione dei cittadini all&#39;attività
            politico-amministrativa dell&#39;Ente nel rispetto dei principi di
            imparzialità, trasparenza e pubblicità dell&#39;azione
            amministrativa;
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            - permettere a tutti i cittadini, compresi quelli impossibilitati a
            partecipare fisicamente, di assistere alle sedute.
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Il trattamento dei dati personali viene effettuato:
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            - per l&#39;esecuzione di un compito di interesse pubblico o
            connesso all&#39;esercizio di pubblici poteri di cui è investito il
            titolare del trattamento (art. 6, par. 1, lett. e) del GDPR, art. 2
            ter del d.lgs.196/2003, art. 38, comma 7 del d.lgs. 267/2000).
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Natura del conferimento
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Il conferimento dei dati è obbligatorio in quanto necessario ai fini
            dell&#39;attività di cui si tratta.
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Modalità di trattamento
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Il trattamento dei dati personali avviene a mezzo di supporti
            digitali, nei modi e nei limiti necessari per perseguire la predetta
            finalità.
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Destinatari o categorie di destinatari
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Dipendenti e/o collaboratori a qualsivoglia titolo di WS, nonché
            soggetti di cui HM si avvale al fine di soddisfare le finalità,
            compresi principalmente all&#39;interno delle seguenti categorie:
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            • Fornitori di servizi informatici (in particolare, fornitori dei
            servizi di hosting e/o di software, nonché dei relativi servizi di
            assistenza);
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            • Consulenti in ambito fiscale e/o legale e/o amministrativo;
            pubbliche autorità e/o privati autorizzati a ricevere i (e/o ad
            accedere ai) dati (Garante per la protezione dei dati personali,
            Procura della Repubblica, privati muniti di apposito ordine
            giudiziale, ecc.).
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Trasferimento extra UE
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            I dati trattati potrebbero essere oggetto di trasferimento verso
            Paesi non appartenenti allo Spazio Economico Europeo (SEE, ossia UE
            + Norvegia, Liechtenstein, Islanda) o verso un&#39;organizzazione
            internazionale. I fornitori (debitamente individuati ai sensi
            dell&#39;art. 28 del GDPR attraverso le Clausole Contrattuali
            Standard) di WS hanno sede in UE, mentre alcuni degli ulteriori
            fornitori di cui si avvalgono gli stessi, pur avendo la sede legale
            in UE, potrebbero eseguire dei trasferimenti extra SEE: ad esempio,
            qualora fossero necessarie attività di manutenzione e intervento da
            parte dello stabilimento principale situato in USA per i servizi
            cloud di fornitori come Amazon (AWS) o Google (GCP). In tale
            fattispecie, il trasferimento avverrebbe nel pieno rispetto delle
            garanzie previste dal Data Privacy Framework (DPF).
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Periodo di conservazione dei dati
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            I dati sono conservati per il tempo necessario al conseguimento
            delle finalità di trattamento. Le registrazioni rimarranno
            disponibili sul sito sino al termine dell&#39;affidamento.
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h5'
            component='h3'
            className={classes.subsectionTitle}
          >
            Cookie policy
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Il Sito potrebbe utilizzare i cosiddetti &#34;cookie&#34;, ovverosia
            piccoli file di testo conservati nella memoria del dispositivo
            impiegato per la navigazione tramite il browser, aventi effetti di
            varia natura quali la conservazione di alcune informazioni
            riferibili all&#39;interessato (quali, ad esempio, le impostazioni
            preferite dall&#39;utente interessato per la navigazione sul Sito),
            l&#39;elaborazione di statistiche sugli accessi al Sito e
            sull&#39;uso dello stesso, che il browser potrebbe ritrasmettere al
            titolare al prossimo accesso dell&#39;interessato al Sito. Il
            titolare è solito distinguere i cookie presenti sul Sito tra
            &#34;tecnici&#34;, ovverosia necessari ai fini della navigazione sul
            Sito e, pertanto, non soggetti a consenso da parte
            dell&#39;interessato, e &#34;opzionali&#34;, ovverosia impiegati per
            l&#39;elaborazione di statistiche relative al Sito e, pertanto, ove
            provenienti da terze parti (ad esempio: i cd. &#34;Google
            analytics&#34;), assoggettati al preventivo consenso espresso
            dell&#39;interessato. È possibile modificare le impostazioni del
            browser in modo da bloccare automaticamente ogni eventuale cookie
            trasmesso dal Sito. In caso di blocco dei cookie, tuttavia,
            l&#39;interessato potrebbe non essere in grado di navigare in tutto
            o in parte sulle pagine del Sito, né di fruire di particolari
            funzionalità. Per poter modificare le impostazioni del browser
            l&#39;interessato dovrà (di seguito si indicano i browser
            maggiormente in uso):
          </Typography>

          <Typography variant='body1' className={classes.paragraph}>
            <strong>Chrome:</strong>
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            1. blocco cookie: cliccare sull&#39;icona &#34;Menù&#34; in alto a
            destra e selezionare la voce &#34;Impostazioni&#34;. Cliccare a
            fondo pagina sul link &#34;Mostra impostazioni avanzate&#34; e alla
            voce &#34;Privacy&#34; cliccare il bottone &#34;Impostazione
            contenuti&#34;. Si aprirà una finestra dove selezionare la voce
            &#34;Blocca cookie di terze parti e dati dei siti&#34;, quindi
            cliccare su &#34;Fine&#34;;
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            2. cancellazione cookie: digitare nella barra degli indirizzi
            &#34;chrome://history/&#34;, quindi selezionare &#34;Cancella dati
            di navigazione…&#34; e, successivamente, la voce &#34;Cookie e altri
            dati di siti e plugin&#34;, ivi verificando che sia attivato il
            segno di spunta in corrispondenza del suo nome e premi &#34;Cancella
            dati di navigazione&#34;.
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            3. Consigliamo comunque di verificare sempre la guida aggiornata
            cliccando qui https://support.google.com/accounts/answer/61416?hl=it
          </Typography>

          <Typography variant='body1' className={classes.paragraph}>
            <strong>Firefox:</strong>
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            1. blocco cookie: cliccare sull&#39;icona &#34;Menù&#34; in alto a
            destra e selezionare la voce &#34;Opzioni&#34;. Nel menù orizzontale
            in alto selezionare &#34;Privacy&#34;. Alla voce
            &#34;Tracciamento&#34; selezionare l&#39;opzione &#34;Richiedi ai
            siti di non effettuare alcun tracciamento&#34;, quindi cliccare su
            &#34;OK&#34;;
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            2. cancellazione cookie: accedere alle opzioni tramite l&#39;icona
            del menu, quindi selezionare la sezione &#34;Privacy&#34;. Alla voce
            &#34;cronologia&#34; scegliere &#34;utilizza impostazioni
            personalizzate&#34;, quindi cliccare sulla voce &#34;Mostra i
            cookie&#34;. Verrà visualizzata l&#39;apposita finestra. Nel campo
            &#34;Cerca&#34; digitare il nome del sito di cui si vogliono
            rimuovere i cookie. Apparirà un elenco che riporta i cookie relativi
            alla ricerca effettuata. Nell&#39;elenco, selezionare i cookie da
            rimuovere e fare click sul pulsante &#34;Rimuovi Selezionato&#34;.
            Per eliminare tutti i cookie memorizzati sul dispositivo utilizzare
            il pulsante &#34;Rimuovi tutti i cookie&#34;.
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            3. Consigliamo comunque di verificare sempre la guida aggiornata
            cliccando qui
            https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie
          </Typography>

          <Typography variant='body1' className={classes.paragraph}>
            <strong>Edge:</strong>
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            1. cliccare sull&#39;icona &#34;rotellina&#34; in alto a destra e
            selezionare la voce &#34;Opzioni Internet&#34;. Si aprirà una
            finestra dove selezionare il tab &#34;Privacy&#34;. Cliccare
            &#34;Avanzate&#34; e nella successiva finestra selezionare
            &#34;Sostituisci gestione automatica cookie&#34;, dopo di che
            selezionare &#34;Blocca&#34; dall&#39;elenco &#34;Cookie di terze
            parti&#34; e – preferibilmente per mantenere inalterate le
            funzionalità del Sito – spuntare &#34;Accetta sempre i cookie di
            sessione&#34;. Infine cliccare su &#34;OK&#34;;
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            2. cancellazione cookie: selezionare &#34;Strumenti&#34;,
            &#34;Opzioni Internet&#34;, quindi &#34;Elimina&#34; dal riquadro
            &#34;Cronologia esplorazioni&#34;. Spuntare quindi la voce
            &#34;Cookies e dati di siti web&#34; e premere &#34;Elimina&#34;.
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            3. Consigliamo comunque di verificare sempre la guida aggiornata
            cliccando qui
            http://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies#ie=ie-11
          </Typography>

          <Typography variant='body1' className={classes.paragraph}>
            <strong>Safari:</strong>
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            1. blocco cookie: cliccare sull&#39;icona a forma di
            &#34;rotellina&#34; in alto a destra e scegliere dall&#39;elenco la
            voce &#34;Preferenze&#34;. Si aprirà una finestra dove cliccare
            l&#39;icona &#34;Privacy&#34; nel menù orizzontale in alto. Alla
            voce &#34;Blocca cookie&#34; selezionare &#34;Di sponsor e terze
            parti&#34;;
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            2. cancellazione cookie: cliccare sulla voce &#34;Preferenze&#34;
            dal menu &#34;Strumenti&#34; (combinazione di tasti CTRL+,), quindi
            selezionare la sezione &#34;Privacy&#34;, cliccare su &#34;Rimuovi
            tutti i dati del sito web&#34; e successivamente confermare la
            scelta. Scegliere la policy di gestione dei cookie scegliendo
            un&#39;opzione da quelle proposte dal programma, quindi chiudere la
            finestra delle opzioni dall&#39;icona di chiusura in alto a destra.
          </Typography>
          <Typography variant='body1' className={classes.listItem}>
            3. Consigliamo comunque di verificare sempre la guida aggiornata
            cliccando qui
            https://support.apple.com/kb/PH19214?viewlocale=it_IT&locale=en_US
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Diritti dell&#39;interessato
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            L&#39;interessato può esercitare i diritti di cui agli artt. 15 e
            seguenti del GDPR, ivi compresi in particolare il diritto di
            accedere ai Suoi dati personali, di opporsi al trattamento o
            chiederne la limitazione, il diritto di chiedere la rettifica,
            l&#39;aggiornamento, la cancellazione e/o la portabilità dei dati
            personali, di revocare il consenso eventualmente prestato.
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Le richieste dovranno essere inoltrate ad WS tramite mail
            all&#39;indirizzo info@writesystem.eu o via posta all&#39;indirizzo
            Via Francesco Capacchione 10, 76121– Barletta(BT).
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Può, inoltre, proporre reclamo all&#39;Autorità di controllo
            competente.
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Diritto di proporre reclamo
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            Gli interessati che ritengono che il trattamento dei dati personali
            a loro riferiti avvenga in violazione di quanto previsto dal
            Regolamento hanno il diritto di proporre reclamo al Garante, come
            previsto dall&#39;art. 77 del Regolamento stesso, o di adire le
            opportune sedi giudiziarie (art. 79 del Regolamento).
          </Typography>
        </div>

        <div className={classes.section}>
          <Typography
            variant='h4'
            component='h2'
            className={classes.sectionTitle}
          >
            Attività di profilazione
          </Typography>
          <Typography variant='body1' className={classes.paragraph}>
            WS non effettua profilazione.
          </Typography>
        </div>
      </div>
    </Layout>
  )
}
